// extracted by mini-css-extract-plugin
export default {"header":"main_header__qANKy","content":"main_content__UxROE","holder":"main_holder__rMboK","contentMain":"main_contentMain__RpEae","headers":"main_headers__jtvtM"};